// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileSyncOutlinedSvg from "@fishx/icons-svg/es/asn/PFileSyncOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileSyncOutlined = function PFileSyncOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileSyncOutlinedSvg
  }));
};

PFileSyncOutlined.displayName = 'PFileSyncOutlined';
export default React.forwardRef(PFileSyncOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileSyncOutlined.js
// module id = 3406
// module chunks = 0